<template>
  <div class="navbar-container d-flex content align-items-center flex-wrap">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
          
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex mr-auto ml-0"
    >
      <ProfileNavbar
        v-if="
          !$route.path.includes('profile') &&
          userData.permissions &&
          !userData.permissions.permissions.length
        "
      />
      <!-- Bookmarks Container -->
      <!-- <bookmarks
        v-if="userData.permissions && userData.permissions.permissions.length"
      /> -->
      <notification-slider  v-if="userData.permissions && userData.permissions.permissions.length" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-link
        class="mr-50 cursor-pointer"
        :to="{ name: 'profile-devices' }"
        v-if="userData.permissions && !userData.permissions.permissions.length"
      >
        <feather-icon
          badge="new"
          badge-classes="bg-danger"
          icon="AirplayIcon"
          size="21"
          class="text-body"
        />
      </b-link>
      <bookmarks
        v-if="userData.permissions && !userData.permissions.permissions.length"
      />
      <dark-Toggler />
      <!-- <search-bar /> -->
      <!-- <cart-dropdown />
     -->

      <!-- <notification-dropdown :count="count" /> -->
      <div class="position-relative mx-25 d-sm-flex d-none">
        <span>داشبورد معاملاتی</span>
        <small>
          <b-badge
            varient="primary"
            class="position-absolute position-bottom-100 position-right-0"
            >به زودی</b-badge
          >
        </small>
      </div>
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BBadge } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import DarkToggler from "./components/DarkToggler.vue";
import CartDropdown from "./components/CartDropdown.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import UserDropdown from "./components/UserDropdown.vue";
import ProfileNavbar from "@/views/pages/profile/profile-header/ProfileVerticalNav.vue";
import notificationSlider from "./components/notification-slider.vue";
export default {
  components: {
    BLink,
    ProfileNavbar,
    // Navbar Components
    notificationSlider,
    BNavbarNav,
    Bookmarks,
    BBadge,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  async mounted() {
    if (Object.keys(this.userData).length) {
      const { data } = await this.$http.get("/panel/notifications/count");
      this.$store.dispatch("appConfig/getNotifCount", data.data.count);
      setInterval(async () => {
        const { data } = await this.$http.get("/panel/notifications/count");
        this.$store.dispatch("appConfig/getNotifCount", data.data.count);
      }, 900000);
    }
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
